(function () {
  const SECTION_SELECTOR = ".recommended-products";

  function formatMoney(cents, moneyFormat) {
    if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, moneyFormat || window.money_format);
    }

    return `$${(Number(cents || 0) / 100).toFixed(2)}`;
  }

  async function refreshCartCount() {
    try {
      const response = await fetch("/cart.js", {
        headers: { Accept: "application/json" }
      });

      if (!response.ok) return;
      const cart = await response.json();

      window.updateCartCountBadges(cart.item_count);

      const totalPrice = document.querySelector("header-total-price");
      if (totalPrice && typeof totalPrice.updateTotal === "function") {
        totalPrice.updateTotal(cart);
      }

      const freeShip = document.querySelector("free-ship-progress-bar");
      if (freeShip && typeof freeShip.init === "function") {
        freeShip.init(cart.items_subtotal_price);
      }
    } catch (error) {
    }
  }

  function getCartUi() {
    return document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  }

  function replaceCartSections(cartUi, sections) {
    if (!cartUi || !sections || typeof cartUi.getSectionsToRender !== "function") return;

    cartUi.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      const htmlString = sections[section.id];

      if (!container || !htmlString) return;

      const parsedDocument = new DOMParser().parseFromString(htmlString, "text/html");
      const replacement =
        parsedDocument.getElementById(section.id) ||
        parsedDocument.querySelector(".shopify-section") ||
        parsedDocument.body;

      if (replacement) {
        container.innerHTML = replacement.innerHTML;
      }
    });

    if (cartUi.classList.contains("is-empty")) {
      cartUi.classList.remove("is-empty");
    }
  }

  function refreshLazyImages() {
    if (typeof window.BlsLazyloadImg !== "undefined" && window.BlsLazyloadImg && typeof window.BlsLazyloadImg.init === "function") {
      window.BlsLazyloadImg.init();
    }
  }

  class RecommendedProductsCard {
    constructor(card, moneyFormat) {
      this.card = card;
      this.moneyFormat = moneyFormat || window.money_format;
      this.form = card.querySelector("[data-rp-form]");
      this.variantInput = card.querySelector("[data-rp-variant-id]");
      this.variantSelect = card.querySelector("[data-rp-variant-select]");
      this.price = card.querySelector("[data-rp-price]");
      this.image = card.querySelector("[data-rp-image]");
      this.hasCustomImage = card.dataset.rpHasCustomImage === "true";
      this.submit = card.querySelector("[data-rp-submit]");
      this.submitText = card.querySelector("[data-rp-submit-text]");
      this.message = card.querySelector("[data-rp-message]");
      this.productJson = card.querySelector("[data-rp-product-json]");
      this.product = null;
      this.currentVariant = null;
      this.messageTimer = null;

      if (!this.form || !this.productJson) return;

      this.initProduct();
      this.bindEvents();
    }

    initProduct() {
      try {
        this.product = JSON.parse(this.productJson.textContent);
      } catch (error) {
        this.product = null;
      }

      if (!this.product || !Array.isArray(this.product.variants)) return;

      const initialVariantId = this.variantSelect ? this.variantSelect.value : this.variantInput ? this.variantInput.value : null;
      this.updateVariant(initialVariantId);
    }

    bindEvents() {
      if (this.variantSelect) {
        this.variantSelect.addEventListener("change", (event) => {
          this.updateVariant(event.target.value);
        });
      }

      this.form.addEventListener("submit", (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }

    getVariantById(variantId) {
      if (!this.product || !variantId) return null;
      return this.product.variants.find((variant) => String(variant.id) === String(variantId)) || null;
    }

    updateVariant(variantId) {
      const variant = this.getVariantById(variantId);
      this.currentVariant = variant;

      if (this.variantInput) {
        this.variantInput.value = variant ? variant.id : "";
      }

      if (this.price && variant) {
        this.price.textContent = formatMoney(variant.price, this.moneyFormat);
      }

      if (!this.hasCustomImage && this.image && variant && variant.featured_image && variant.featured_image.src) {
        this.image.src = variant.featured_image.src;
        if (variant.featured_image.srcset) this.image.srcset = variant.featured_image.srcset;
        if (variant.featured_image.alt) this.image.alt = variant.featured_image.alt;
      }

      this.updateButton(false);
    }

    updateButton(isLoading) {
      if (!this.submit || !this.submitText) return;

      const defaultLabel = this.submit.dataset.defaultLabel || "ADD TO CART";
      const loadingLabel = this.submit.dataset.loadingLabel || "ADDING...";
      const soldOutLabel = this.submit.dataset.soldOutLabel || "SOLD OUT";

      if (isLoading) {
        this.submit.disabled = true;
        this.submitText.textContent = loadingLabel;
        return;
      }

      if (!this.currentVariant || !this.currentVariant.available) {
        this.submit.disabled = true;
        this.submitText.textContent = soldOutLabel;
        return;
      }

      this.submit.disabled = false;
      this.submitText.textContent = defaultLabel;
    }

    showMessage(text, isError) {
      if (!this.message) return;

      window.clearTimeout(this.messageTimer);

      if (!text) {
        this.message.textContent = "";
        this.message.hidden = true;
        this.message.classList.remove("is-visible", "is-error");
        return;
      }

      this.message.textContent = text;
      this.message.hidden = false;
      this.message.classList.add("is-visible");
      this.message.classList.toggle("is-error", Boolean(isError));

      if (!isError) {
        this.messageTimer = window.setTimeout(() => {
          this.message.classList.remove("is-visible");
          window.setTimeout(() => {
            this.message.hidden = true;
          }, 240);
        }, 2000);
      }
    }

    async addToCart() {
      if (!this.currentVariant || !this.currentVariant.available) {
        this.updateButton(false);
        return;
      }

      this.updateButton(true);
      this.showMessage("", false);

      try {
        const cartUi = getCartUi();
        const config = {
          method: "POST",
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest"
          }
        };

        const formData = new FormData(this.form);

        if (cartUi && typeof cartUi.getSectionsToRender === "function") {
          formData.append(
            "sections",
            cartUi.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
        }

        config.body = formData;

        const response = await fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : "/cart/add", config);

        if (!response.ok) {
          throw new Error("Cart request failed");
        }

        const parsedState = JSON.parse(await response.text());

        if (parsedState && parsedState.sections) {
          replaceCartSections(cartUi, parsedState.sections);
        }

        refreshLazyImages();
        this.showMessage("Added to cart", false);
        await refreshCartCount();

        if (cartUi && typeof cartUi.cartAction === "function") {
          cartUi.cartAction();
        }

        if (cartUi && typeof cartUi.open === "function") {
          cartUi.open();
        }

        refreshLazyImages();
      } catch (error) {
        this.showMessage("Unable to add to cart", true);
      } finally {
        window.setTimeout(() => {
          this.updateButton(false);
        }, 2000);
      }
    }
  }

  class RecommendedProductsSection {
    constructor(section) {
      if (section.dataset.rpInitialized === "true") return;

      section.dataset.rpInitialized = "true";
      this.section = section;
      this.moneyFormat = window.money_format || section.dataset.moneyFormat;
      this.track = section.querySelector("[data-rp-track]");
      this.initCards();
      this.resetTrackPosition();
      this.bindEvents();
    }

    initCards() {
      this.section.querySelectorAll("[data-rp-card]").forEach((card) => {
        new RecommendedProductsCard(card, this.moneyFormat);
      });
    }

    bindEvents() {
      this.handleResize = this.resetTrackPosition.bind(this);
      window.addEventListener("resize", this.handleResize, { passive: true });
    }

    resetTrackPosition() {
      if (!this.track) return;

      if (window.innerWidth >= 1400) return;

      window.requestAnimationFrame(() => {
        this.track.scrollLeft = 0;
      });
    }
  }

  function initSections(root) {
    (root || document).querySelectorAll(SECTION_SELECTOR).forEach((section) => {
      new RecommendedProductsSection(section);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initSections(document));
  } else {
    initSections(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initSections(event.target);
  });
})();
